import $ from "jquery";
import ClipboardJS from "clipboard";
import * as utils from './utils';
import * as api from './api';
import * as render from './render';
import Animation from './animation';
import bagTip from './bagTip';
import errorTip from "./errorTip";
import tip from "./tip";
import { setGameList, setServerList, setRoleList } from "./common";
import * as activityInit from './service';

const DOT = activityInit.init();
const DEVICE_TYPE = utils.deviceType();
const BOOL_MOBILE = DEVICE_TYPE === 'android' || DEVICE_TYPE === 'ios';
let animation = null;
let isPlayEgg = false;

// console.log(utils.getParam('scid'), utils.getParam('cid'));

// 来源统计
dataLayer.push({
  event: 'entrance',
  scid: utils.getParam('scid'),
  cid: utils.getParam('cid')
});

const _loopSetBoxStatus = (day) => {
  if (day < 1 || day > 4) {
    return;
  }
  for (let i = 1; i <= 4; i++) {
    if (i > day) {
      break;
    }
    render.setBoxStatus(i, 'got');
  }
  if (i <= 3) {
    render.setBoxStatus(day + 1, 'get');
  }
}

const _commonSignHandler = (data, isFinal = false) => {
  if (!data.gift) {
    render.setTipPopup(tip.tipError);
    render.showPopup('tip');
    return;
  }
  let gameId = data.gift.game_id;
  let award = bagTip[gameId] && bagTip[gameId][data.gift.gift_key];
  let awardName = '';
  if (!award) {
    render.setTipPopup(tip.tipError);
    render.showPopup('tip');
    return;
  }
  // 更新签到天数
  !isFinal && render.setSignTime(data.sign_num);

  // 最终签到 更新[宝箱]和[按钮]状态
  if (isFinal) {
    _loopSetBoxStatus(4);
    render.setSignBtn(0);
    // 弹窗显示
    awardName = award.name + '：' + award.content;
    render.setTipPopup(tip.tipSignAward(awardName));
    render.showPopup('tip');
    return;
  }

  // 普通签到 更新宝箱状态
  _loopSetBoxStatus(data.sign_num);
  data.sign_num == 3 ? render.setSignBtn(2) : render.setSignBtn(0);
  // 弹窗显示
  awardName = award.name + '：' + award.content;
  render.setTipPopup(tip.tipSignAward(awardName));
  render.showPopup('tip');
  window.activity.signNum = data.sign_num;
}

const _updateEggTime = (data) => {
  data.bind_data && render.setEggTime(+data.lottery_times, false);
  data.lottery_times > 0 ?
    render.setGameStartStatus(false) :
    render.setGameStartStatus(true);
}


$(function () {

  animation = new Animation();
  // window.animation = animation;

  $('.j-full-shadow').on('click', function () {
    $(this).fadeOut(100);
    window.activity.$activePopup && window.activity.$activePopup.fadeOut(100);
    window.activity.$activePopup = null;
  })

  $('.j-popup-close').on('click', function () {
    $('.j-full-shadow').fadeOut(100);
    window.activity.$activePopup && window.activity.$activePopup.fadeOut(100);
    window.activity.$activePopup = null;
  })

  $('.j-award-btn').on('click', async () => {
    const awardLogResponse = await api.getRequest('awardLog');
    // const awardLogResponse = {
    //   "code": 1,
    //   "result": 1,
    //   "msg": "领奖成功",
    //   "data": [
    //     {
    //       "is_card": 0,
    //       "date": "2021-09-01 15:53:56",
    //       "game_id": 52,
    //       "gift_key": "sign_1",
    //       "game": "叫我大掌櫃",
    //       "card": ""
    //     },
    //     {
    //       "is_card": 0,
    //       "date": "2021-09-01 16:08:55",
    //       "game_id": 52,
    //       "gift_key": "sign_2",
    //       "game": "叫我大掌櫃",
    //       "card": ""
    //     },
    //     {
    //       "is_card": 0,
    //       "date": "2021-09-01 16:17:22",
    //       "game_id": 52,
    //       "gift_key": "sign_3",
    //       "game": "叫我大掌櫃",
    //       "card": ""
    //     },
    //     {
    //       "is_card": 0,
    //       "date": "2021-09-01 16:17:26",
    //       "game_id": 52,
    //       "gift_key": "sign_total",
    //       "game": "叫我大掌櫃",
    //       "card": ""
    //     },
    //     {
    //       "is_card": 1,
    //       "date": "2021-09-01 16:17:26",
    //       "game_id": 52,
    //       "gift_key": "lottery_52_1",
    //       "game": "叫我大掌櫃",
    //       "card": "duewhfw"
    //     },
    //     {
    //       "is_card": 1,
    //       "date": "2021-09-01 16:17:26",
    //       "game_id": 53,
    //       "gift_key": "lottery_53_7",
    //       "game": "thanks",
    //       "card": "duewhfw"
    //     },
    //     {
    //       "is_card": 1,
    //       "date": "2021-09-01 16:17:26",
    //       "game_id": 53,
    //       "gift_key": "lottery_53_8",
    //       "game": "quan",
    //       "card": "duewhfw"
    //     },
    //     {
    //       "is_card": 1,
    //       "date": "2021-09-01 16:17:26",
    //       "game_id": 53,
    //       "gift_key": "lottery_53_9",
    //       "game": "quan",
    //       "card": "duewhfw"
    //     },
    //     {
    //       "is_card": 1,
    //       "date": "2021-09-01 16:17:26",
    //       "game_id": 53,
    //       "gift_key": "lottery_53_10",
    //       "game": "quan",
    //       "card": "duewhfw"
    //     },
    //   ]
    // }
    if (+awardLogResponse.result) {
      let gitfArr = [];
      let quanArr = [];
      let responseArr = awardLogResponse.data;
      for (let i = 0, length = responseArr.length; i < length; i++) {
        // 谢谢参与
        if ('lottery_53_7' == responseArr[i].gift_key) {
          continue;
        }
        // 礼卷
        if (['lottery_53_8', 'lottery_53_9', 'lottery_53_10'].includes(responseArr[i].gift_key)) {
          quanArr.push(responseArr[i]);
          continue;
        }
        // 礼包
        gitfArr.push(responseArr[i]);
      }
      // console.log(gitfArr);
      // console.log(quanArr);
      render.setAwardPopupTicket(gitfArr);
      render.setAwardPopupBag(quanArr);
      render.showPopup('award');
      return;
    }
    render.errorHandler(awardLogResponse);

  })

  $('.j-rule-btn').on('click', function () {
    render.showPopup('rule');
  })

  $('.j-change-ticket').on('click', function () {
    $('.j-change-bag').removeClass('active');
    $(this).addClass('active');
    $('.j-popup-ticketlist').hide();
    $('.j-popup-baglist').show();
  })

  $('.j-change-bag').on('click', function () {
    $('.j-change-ticket').removeClass('active');
    $(this).addClass('active');
    $('.j-popup-baglist').hide();
    $('.j-popup-ticketlist').show();
  })

  $('.j-change-game').on('click', async () => {
    // 判断是否已登录
    if (!window.activity.login) {
      render.setTipPopup(tip.login);
      render.showPopup('login');
      return;
    }
    // render.setSelectPopup();
    if (boolFromSDK) {
      render.showPopup('select');
      await setGameList(SDK_PARAM.gameId || SDK_PARAM.game_id);
      await setServerList(SDK_PARAM.serverId || SDK_PARAM.sid);
      await setRoleList(SDK_PARAM.roleId || SDK_PARAM.role_id);
      return;
    }
    render.showPopup('select');
    await setGameList();
    await setServerList();
    await setRoleList();
  })

  $('.j-game-select').on('change', async ({ target }) => {
    // console.log('game');
    gameInfo.game.id = target.options[target.options.selectedIndex].value;
    gameInfo.game.name = target.options[target.options.selectedIndex].innerText;
    await setServerList();
    await setRoleList();
  })

  $('.j-server-select').on('change', async ({ target }) => {
    // console.log('server');
    gameInfo.server.id = target.options[target.options.selectedIndex].value;
    gameInfo.server.sid = target.options[target.options.selectedIndex].dataset.sid;
    gameInfo.server.name = target.options[target.options.selectedIndex].innerText;
    await setRoleList();
  })

  $('.j-role-select').on('change', async ({ target }) => {
    // console.log('role');
    gameInfo.role.id = target.options[target.options.selectedIndex].value;
    gameInfo.role.name = target.options[target.options.selectedIndex].innerText;
  })

  $('.j-select-confirm').on('click', async () => {
    // let optionObj = render.getSelectOption();
    // if (optionObj.game == '' || optionObj.server == '' || optionObj.role == '') {
    //   render.hidePopup('select');
    //   render.setTipPopup(tip.tipBind);
    //   render.showPopup('tip');
    //   return;
    // }
    render.hidePopup('select');
    // 开始绑定游戏
    const { game, server, role } = window.gameInfo;
    // 非空输入校验
    if(game.id == '' || server.sid == '' || server.name == '' || role.id == '' || role.name == '') {
      render.hidePopup('select');
      render.setTipPopup(tip.tipBind);
      render.showPopup('tip');
      return;
    }
    // 游戏 服务器 角色 一一对应校验
    // const listResponse = await Promise.all([
    //   api.getRequest('list_server', { gameId: game.id }),
    //   api.getRequest('get_mobile_game_role', {game_id: game.id, server_id: server.sid })
    // ]);
    // const serverResponse = listResponse[0];
    // const roleResponse = listResponse[1];
    // if(!serverResponse.result || !roleResponse.result) {
    //   render.setTipPopup(tip.eval);
    //   render.showPopup('tip');
    //   return;
    // }
    // let serverArr = serverResponse.data;
    // let roleArr = roleResponse.data;
    // // 校验游戏是否和服务器一致
    // let boolHasServer = serverArr.some((item) => {
    //   return item.sid == server.sid;
    // })
    // // 校验服务器是否和角色一致
    // let boolHasRole = roleArr.some((item) => {
    //   return item.id == role.roleID;
    // })
    // // console.log(boolHasServer, boolHasRole);
    // // 弹窗提示
    // if(!boolHasServer || !boolHasRole) {
    //   render.setTipPopup(tip.eval);
    //   render.showPopup('tip');
    //   return;
    // }
    // 开始绑定
    const bindResponse = await api.getRequest('bind', {
      game_id: game.id,
      server_id: server.sid,
      role_id: encodeURIComponent(role.id),
      server_name: encodeURIComponent(server.name),
      role_name: encodeURIComponent(encodeURIComponent(role.name))
    })
    if (+bindResponse.result) {
      // 更新奖品信息
      render.setAwardList(game.id);
      // 更新绑定信息
      let { game_id, server_name, role_name } = bindResponse.data.bind_data;
      game_id += '';
      let gameName = bagTip[game_id] && bagTip[game_id].name;
      server_name = decodeURIComponent(server_name);
      role_name = decodeURIComponent(role_name);
      // 展示绑定信息
      render.setGameInfo(true, gameName, server_name, role_name);
      // 记录已绑定
      window.activity.boolBinded = true;
    } else {
      render.errorHandler(bindResponse);
    }
  })

  $('.j-open-box').on('click', async function () {
    // 判断是否指定游戏和服务器
    if (!window.activity.boolBinded) {
      render.setTipPopup(tip.tipBind);
      render.showPopup('tip');
      return;
    }
    // 绑好角色
    let signResponse = window.activity.signNum == 3 ?
      await api.getRequest('signTotal') :
      await api.getRequest('sign');

    // const test = {
    //   "code": 1,
    //   "result": 1,
    //   "msg": "领奖成功",
    //   "data": {
    //     "gift": {
    //       "is_card": 0,
    //       "date": "2021-09-01 16:08:55",
    //       "game_id": 28,
    //       "gift_key": "sign_total",
    //       "game": "江湖大夢",
    //       "card": ""
    //     }
    //   }
    // };
    // signResponse = test;
    // window.activity.signNum = 3;

    if (+signResponse.result) {
      _commonSignHandler(signResponse.data, window.activity.signNum == 3);
      // 更新抽奖次数
      const basicResponse = await api.getRequest('basic');
      +basicResponse.result ? _updateEggTime(basicResponse.data) : render.errorHandler(basicResponse);
      // 打点
      if (window.boolFromSDK) {
        dataLayer.push({ 'event': 'sdkSignSuccess' });
        DOT.log('SDK签到成功次数', 'click');
        DOT.log('SDK签到成功人数', 'user');
      } else {
        dataLayer.push({ 'event': 'signSuccess' });
        DOT.log('非SDK签到成功次数', 'click');
        DOT.log('非SDK签到成功人数', 'user');
      }
    } else {
      if (window.boolFromSDK) {
        dataLayer.push({ 'event': 'sdkSignFail' });
        DOT.log('SDK签到失败次数', 'click');
        DOT.log('SDK签到失败人数', 'user');
      } else {
        dataLayer.push({ 'event': 'signFail' });
        DOT.log('非SDK签到失败次数', 'click');
        DOT.log('非SDK签到失败人数', 'user');
      }
      render.errorHandler(signResponse);
    }
  })

  $('.j-bind').on('click', async () => {
    let url = BOOL_MOBILE ? '//m.gm99.com/user/bind_phone' : 'https://www.gm99.com/center/';
    window.open(url, '_blank');
  })

  $('.j-egg-start').on('click', async function () {
    if (isPlayEgg) {
      return;
    }
    isPlayEgg = true;
    animation.reset();
    const lotteryResponse = await api.getRequest('lottery');
    if (!+lotteryResponse.result) {
      if (lotteryResponse.code + '' == '-20009') {
        render.setEggTime(0, true);
        render.setGameStartStatus(true);
      }
      render.errorHandler(lotteryResponse);
      isPlayEgg = false;
      return;
    }
    // 播放动画
    await animation.start();

    // 展示弹窗
    let giftKey = lotteryResponse.data.gift.gift_key;
    let gameId = lotteryResponse.data.gift.game_id + '';
    let awardName = '';
    let awardContent = '';

    // 最强王者特殊处理
    if (gameId == 53 && giftKey == 'lottery_53_7') {
      render.setTipPopup({
        type: 'tip',
        title: '請再接再厲',
        text: '謝謝您的參與，本次沒有抽中獎勵，下次一定會更好運的！',
        info: '',
        btn: '我知道了'
      })
      render.showPopup('tip');
      // 还原蛋蛋
      animation.reset();
      // 更新抽奖次数
      let eggTime = lotteryResponse.data.lottery_times;
      render.setEggTime(+eggTime, eggTime == 0);
      eggTime == 0 ?
        render.setGameStartStatus(true) :
        render.setGameStartStatus(false);
      // 打点
      if (window.boolFromSDK) {
        dataLayer.push({ 'event': 'sdkLotterySuccess' });
        DOT.log('SDK抽奖成功次数', 'click');
        DOT.log('SDK抽奖成功人数', 'user');
      } else {
        dataLayer.push({ 'event': 'lotterySuccess' });
        DOT.log('非SDK抽奖成功次数', 'click');
        DOT.log('非SDK抽奖成功人数', 'user');
      }
      isPlayEgg = false;
      return;
    }

    // 出现错误
    if (!bagTip[gameId] || !bagTip[gameId][giftKey]) {
      render.setTipPopup(tip.tipError);
      render.showPopup('tip');
      isPlayEgg = false;
      if (window.boolFromSDK) {
        dataLayer.push({ 'event': 'sdkLotteryFail' });
        DOT.log('SDK抽奖失败次数', 'click');
        DOT.log('SDK抽奖失败人数', 'user');
      } else {
        dataLayer.push({ 'event': 'lotteryFail' });
        DOT.log('非SDK抽奖失败次数', 'click');
        DOT.log('非SDK抽奖失败人数', 'user');
      }
      return;
    }

    awardName = bagTip[gameId][giftKey].name;
    awardContent = bagTip[gameId][giftKey].content;

    // console.log(awardName, awardContent);

    if (lotteryResponse.data.gift.is_card == 1) {
      // 是礼包码-要copy
      let awardCode = lotteryResponse.data.gift.card;
      window.awardCode = awardCode;
      render.setTipPopup(tip.tipLuckyAwardCode(awardName, awardContent, awardCode));
      render.showPopup('luckily');
    } else {
      // 不是礼包码
      // console.log(lotteryResponse.data.gift);
      render.setTipPopup(tip.tipLuckyAward(awardName, awardContent));
      render.showPopup('tip');
    }
    // 还原蛋蛋
    animation.reset();
    // 更新抽奖次数
    let eggTime = lotteryResponse.data.lottery_times;
    render.setEggTime(+eggTime, eggTime == 0);
    eggTime == 0 ?
      render.setGameStartStatus(true) :
      render.setGameStartStatus(false);
    // 打点
    if (window.boolFromSDK) {
      dataLayer.push({ 'event': 'sdkLotterySuccess' });
      DOT.log('SDK抽奖成功次数', 'click');
      DOT.log('SDK抽奖成功人数', 'user');
    } else {
      dataLayer.push({ 'event': 'lotterySuccess' });
      DOT.log('非SDK抽奖成功次数', 'click');
      DOT.log('非SDK抽奖成功人数', 'user');
    }
    isPlayEgg = false;
  })

  $('.j-popup-btn').on('click', function () {
    const POPUP_HANDLER_TYPE = window.activity.popupHandlerType;
    if (!['tip', 'login'].includes(POPUP_HANDLER_TYPE)) {
      throw new Error('It is not found a type for this popup');
    }
    // console.log(POPUP_HANDLER_TYPE);
    render.hidePopup(POPUP_HANDLER_TYPE);
    POPUP_HANDLER_TYPE === 'login' &&
      window.open(`//passport.gm99.com/?device=2&forward=${encodeURIComponent(window.location.href)}`, '_self');
  })

  let gameTimer = null;
  $('.j-go-game').on('click', ({ target }) => {
    let { href, download } = target.dataset;
    let newPage = null;
    if (!href) {
      return;
    }
    newPage = window.open(href, '_blank');
    setTimeout(() => {
      try {
        (newPage.location.href == 'about:blank' || !newPage.location.href) && window.open(download, '_blank');
      } catch (e) { }
    }, 2000)
  })

  !BOOL_MOBILE && $('.j-nav').on('click', function ({ target }) {
    let index = +target.dataset.index;
    if (![1, 2, 3, 4].includes(index)) {
      return;
    }
    if (index == 4) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
      return;
    }
    let top = utils.computeEleLocation(document.getElementById(`part${index}`));
    window.scrollTo({
      top,
      behavior: "smooth"
    })
  })

  // 抽奖弹窗复制
  const clipboardAward = new ClipboardJS('.j-popup-copy', {
    text: function () {
      return window.awardCode;
    }
  })

  clipboardAward.on('success', (e) => {
    // console.log(e, 'copy sucess');
  })

  clipboardAward.on('error', (e) => {
    // console.log(e, 'copy error');
  })

  // window.addEventListener('focus', utils.antiShake(async () => {
  //   // 更新抽奖次数
  //   const basicResponse = await api.getRequest('basic');
  //   +basicResponse.result ? _updateEggTime(basicResponse.data) : render.errorHandler(basicResponse);
  // }), 3000);

  // 5s检查更新一下中奖名单
  setInterval(() => {
    render.setAwardPlayers();
  }, 5000)

})

window.login = function () {
  window.open(`//passport.gm99.com/?device=2&forward=${window.location.href}`, '_self');
}

window.logout = async function () {
  const RESPONSE = await api.logout();
  if (+RESPONSE.result == 1) {
    // 更新登录状态
    window.activity.login = false;
    // 还原用户登录
    render.setUserInfo('', false);
    // 还原游戏信息
    render.setGameInfo(false);
    // 还原宝箱状态
    render.setBoxStatus(1, 'get');
    render.setBoxStatus(2, 'two');
    render.setBoxStatus(3, 'three');
    render.setBoxStatus(4, 'to-three');
    // 还原签到按钮状态
    render.setSignBtn(1);
    // 还原签到时间
    render.setSignTime(-1);
    // 还原抽奖次数
    render.setEggTime(0, false);
    render.setGameStartStatus(true);
    return;
  }
  // 登出失败，刷新页面
  window.location.reload();
}




